import {find, findFirst} from "@21torr/dune/dom/traverse.js";
import {on, trigger} from "@21torr/dune/dom/events.js";
import {isBlank, isEmpty} from "../util/type-utils.js";
import MoveTo from "moveto";
import {isScrolledIntoView} from "../util/scroll-utils.js";

export const ACCORDION_ROW_BUTTON_SELECTOR = '.accordion-button';
export const ACCORDION_ROW_WRAPPER_SELECTOR = '.accordion-wrapper';

export const ACCORDION_CHANGE_EVENT = "library:accordion:change";

/**
 * Init accordion and add open close function
 */
export function initAccordion(container) {

    const accordionButtons = find(ACCORDION_ROW_BUTTON_SELECTOR, container);
    const panels = find(ACCORDION_ROW_WRAPPER_SELECTOR, container);


    if (!accordionButtons.length) {
        return;
    }

    let initalLoad = true;


    // Update accordion panel height on visibility changes.
    accordionButtons.forEach(button => {
        const accordionItem = button.parentElement,
            content = findFirst('.accordion-panel', accordionItem);

        let intersectionObserver = new IntersectionObserver(e => {
            if (accordionItem.classList.contains("is-active")) {
                content.style.height = content.scrollHeight + 'px';
            }
        }, null);

        intersectionObserver.observe(accordionItem);
    })

    on(accordionButtons, "click", event => {
            const button = event.currentTarget;
            const accordionItem = button.parentElement;

            let wasPreviouslyOpen = accordionItem.classList.contains('is-active');
            const content = findFirst('.accordion-panel', accordionItem);

            // close all elements
            panels.forEach(item => {
                findFirst('.accordion-panel', item).style.height = '0px';
                item.classList.remove("is-active");
            });


            if (!wasPreviouslyOpen) {
                accordionItem.classList.add("is-active");

                let observer = new MutationObserver(() => content.style.height = content.scrollHeight + 'px');
                observer.observe(accordionItem, {childList: true, subtree: true});
                content.style.height = content.scrollHeight + 'px';

                if (!initalLoad) {

                    setTimeout(() => {
                        if (!isScrolledIntoView(button)) {

                            const moveTo = new MoveTo({
                                tolerance: 200
                            });

                            moveTo.move(button);
                        }
                    }, 150); // css transitions take 150s
                }

                accordionItem.dispatchEvent(new CustomEvent(ACCORDION_CHANGE_EVENT));
            }
        }
    );

    setTimeout(() => {
        initalLoad = false;
    }, 250);
}




